import {
  ListItemIcon as MuiListItemIcon,
  type ListItemIconProps as MuiListItemIconProps,
} from '@mui/material';

/**
 * Props for configuring a card menu item icon component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @property {MuiListItemIconProps} props - The props for the list item icon.
 */

export const CardMenuItemIcon = ({ ...props }: MuiListItemIconProps) => {
  return <MuiListItemIcon sx={{ paddingRight: '20px' }} {...props} />;
};
